import React from 'react';
import { Combobox } from 'medere-ui-framework';
import { useIntl } from 'react-intl';
import { ComboDataDTO } from '../dto/ComboDataDTO';
import { getCitiesFromMedereData } from '../services/LocationController';

interface CityLocationComboProps {
  value: ComboDataDTO | null
  onChange: (value: ComboDataDTO | null) => void
  error?: boolean
  className?: string
  disabled?: boolean
  label?: string
  placeholder?: string
  autocompleteClassName?: string
  required?: boolean
}

export default function CityLocationCombo({
  value,
  onChange,
  error = false,
  className = '',
  disabled = false,
  label,
  placeholder = 'Seleccionar',
  autocompleteClassName = 'combobox-border',
  required = false,
}: Readonly<CityLocationComboProps>) {
  const intl = useIntl();

  return (
    <Combobox
      className={className}
      value={value}
      label={label ?? intl.formatMessage({ id: 'City' })}
      floatLabel
      error={error}
      placeholder={placeholder}
      autocompleteClassName={autocompleteClassName}
      getItems={getCitiesFromMedereData}
      optionLabel="name"
      disable={disabled}
      setValue={(city: ComboDataDTO | null) => onChange(city)}
      required={required}
    />
  );
}
